var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", [
    _vm._v(" Your license "),
    _vm.licenceData.isExpired ? _c("span", [_vm._v("expired")]) : _vm._e(),
    _vm.licenceData.isExpiring && !_vm.licenceData.isExpired
      ? _c("span", [_vm._v("will expire")])
      : _vm._e(),
    _vm._v(" on "),
    _c("strong", [
      _vm._v(
        _vm._s(
          _vm.$filters.formatDateLocale(
            _vm.licenceData.expiryDate,
            this.$userInfo.locale,
            "short"
          )
        )
      ),
    ]),
    _vm._v(". "),
    !_vm.licenceData.isGracePeriod
      ? _c("span", [_vm._v(" Editing is disabled")])
      : _vm._e(),
    _vm.licenceData.isGracePeriod
      ? _c("span", [
          _vm._v(" Editing will be disabled on "),
          _c("strong", [
            _vm._v(
              _vm._s(
                _vm.$filters.formatDateLocale(
                  _vm.graceExpiryDate,
                  this.$userInfo.locale,
                  "short"
                )
              )
            ),
          ]),
          _vm._v(". "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }